import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ContaCorrente } from '../page/conta-corrente/contacorrente';

@Injectable({ providedIn: 'root' })
export class ContaCorrenteService {

  private apiURL = environment.apiBaseUrl + 'contaCorrente';

  constructor(private http: HttpClient) { }

  listar(): Observable<ContaCorrente[]> {
    return this.http.get<ContaCorrente[]>(this.apiURL);
  }

  buscar(id: number): Observable<ContaCorrente> {
    return this.http.get<ContaCorrente>(`${this.apiURL}/${id}`);
  }

  salvar(conta: ContaCorrente): Observable<ContaCorrente> {
    if (conta.id) {
      return this.http.put<ContaCorrente>(`${this.apiURL}/${conta.id}`, conta);
    }
    return this.http.post<ContaCorrente>(this.apiURL, conta);
  }

  excluir(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiURL}/${id}`);
  }

  anexarCertificado(id: number, arquivo: File, senha: string): Observable<ContaCorrente> {
    const formData = new FormData();
    formData.append('arquivo', arquivo);
    formData.append('senha', senha);
    return this.http.post<ContaCorrente>(`${this.apiURL}/${id}/certificado`, formData);
  }
}
